<template>
  <van-popup v-model="visible" round position="bottom" get-container="#app" :style="{ height: '90%' }">
    <div class="detail-title">{{ title }}<img src="/filter_close.png" @click="close" /></div>
    <div class="container">
      <div class="info">
        <div class="info-title">
          <div>基本信息</div>
          <div class="info-name">{{ detailInfo.mrName }}</div>
        </div>
        <div class="info-content">
          <div class="info-item">
            <div>预估月份</div>
            <div>{{ String(detailInfo.ym) | date('YYYY/MM') }}</div>
          </div>
          <div class="info-item">
            <div>目标医院</div>
            <div>
              <van-popover v-model="customerAgentPopover" placement="top" trigger="click">
                <div class="tips">
                  <div>{{ detailInfo.customerAgentName }}</div>
                </div>
                <template #reference>
                  {{ detailInfo.customerAgentName }}
                </template>
              </van-popover>
            </div>
          </div>
          <div class="info-item">
            <div>SKU</div>
            <div>{{ detailInfo.productName }}</div>
          </div>
          <div class="info-item">
            <div>指标数量</div>
            <div>{{ detailInfo.target | numberFormat(false) }}</div>
          </div>
          <div class="info-item">
            <div>DDI数量(原始)</div>
            <div>{{ detailInfo.mtdOriginNum | numberFormat(false) }}</div>
          </div>
          <div class="info-item">
            <div>DDI数量(标准)</div>
            <div>{{ detailInfo.mtdNum | numberFormat(false) }}</div>
          </div>
          <div class="info-item">
            <div>上月数量(标准)</div>
            <div>{{ detailInfo.lastMonthActualQty | numberFormat(false) }}</div>
          </div>
        </div>
      </div>
      <div class="qty">
        <div class="qty-title">
          <div>预估数量</div>
        </div>
        <div class="qty-content">
          <div class="content-title">原始数量</div>
          <div class="content">
            <div class="qty-item">
              <div>F1原始</div>
              <template v-if="windowInfo.version === 'F1' && detailInfo.ym == windowInfo.ym">
                <el-input-number
                  v-model="originQty"
                  :controls="false"
                  @blur="qtyBlur"
                  v-if="detailInfo.canEdit != 1"
                ></el-input-number>
                <div v-else>{{ detailInfo.f1 | numberFormat(false) }}</div>
              </template>
              <div v-else>{{ detailInfo.f1 | numberFormat(false) }}</div>
            </div>
            <div class="qty-item">
              <div>F2原始</div>
              <template v-if="windowInfo.version === 'F2' && detailInfo.ym == windowInfo.ym">
                <el-input-number
                  v-model="originQty"
                  :controls="false"
                  @blur="qtyBlur"
                  v-if="detailInfo.canEdit != 1"
                ></el-input-number>
                <div v-else>{{ detailInfo.f2 | numberFormat(false) }}</div>
              </template>
              <div v-else>{{ detailInfo.f2 | numberFormat(false) }}</div>
            </div>
            <div class="qty-item">
              <div>Landing原始</div>
              <template v-if="windowInfo.version === 'Landing' && detailInfo.ym == windowInfo.ym">
                <el-input-number
                  v-model="originQty"
                  :controls="false"
                  @blur="qtyBlur"
                  v-if="detailInfo.canEdit != 1"
                ></el-input-number>
                <div v-else>{{ detailInfo.landing | numberFormat(false) }}</div>
              </template>
              <div v-else>{{ detailInfo.landing | numberFormat(false) }}</div>
            </div>
          </div>
        </div>
        <div class="qty-content">
          <div class="content-title">标准数量</div>
          <div class="content">
            <div class="qty-item">
              <div>F1标准</div>
              <div>{{ (detailInfo.f1 * detailInfo.unitInPackNum) | numberFormat(false) }}</div>
            </div>
            <div class="qty-item">
              <div>F2标准</div>
              <div>{{ (detailInfo.f2 * detailInfo.unitInPackNum) | numberFormat(false) }}</div>
            </div>
            <div class="qty-item">
              <div>Landing标准</div>
              <div>{{ (detailInfo.landing * detailInfo.unitInPackNum) | numberFormat(false) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group" v-if="type === 'edit'">
      <van-button class="btn" block @click="close">取消</van-button>
      <van-button class="btn" type="info" block :loading="loading" @click="handleSubmit">提交</van-button>
    </div>
  </van-popup>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import _ from 'lodash'
import moment from 'moment'

export default {
  components: {},
  data() {
    return {
      visible: false,
      loading: false,
      customerAgentPopover: false,
      title: '',
      type: 'edit',
      detailInfo: {}, // 详情信息
      windowInfo: {}, // 窗口信息
      originQty: 0,
    }
  },
  mounted() {},
  methods: {
    edit(record, type, windowInfo) {
      if (type === 'edit') {
        this.title = '预估数量填写'
      } else {
        this.title = '预估数量详情'
      }
      console.log('record', record)
      this.type = type
      this.detailInfo = record
      this.windowInfo = windowInfo
      if (windowInfo.version === 'F1') {
        this.originQty = Math.trunc(record.f1 * 100) / 100
      } else if (windowInfo.version === 'F2') {
        this.originQty = Math.trunc(record.f2 * 100) / 100
      } else {
        this.originQty = Math.trunc(record.landing * 100) / 100
      }
      this.visible = true
    },
    // 取消
    close() {
      this.visible = false
      this.detailInfo = {}
      this.windowInfo = {}
      this.originQty = ''
    },
    // 输入框失焦事件
    qtyBlur() {
      this.originQty = Math.trunc(this.originQty * 100) / 100
    },
    // 提交
    handleSubmit() {
      this.loading = true
      this.originQty = Math.trunc(this.originQty * 100) / 100
      postAction(`/sip/estimate/detail/edit?estimateTimeId=${this.windowInfo.estimateWindowId}`, {
        territorySummariesId: this.detailInfo.territorySummariesId,
        version: this.windowInfo.version,
        estimateNum: this.originQty,
      }).then(res => {
        if (res.success) {
          if (this.windowInfo.version === 'F1') {
            this.detailInfo.f1 = this.originQty
          } else if (this.windowInfo.version === 'F2') {
            this.detailInfo.f2 = this.originQty
          } else {
            this.detailInfo.landing = this.originQty
          }
          this.loading = false
          this.visible = false
          this.originQty = 0
          this.$toast('编辑成功')
          this.$emit('success')
        } else {
          this.$toast(res.message)
        }
      })
    },
    // 修改原始数量
    handleChange(val) {
      console.log('val', val)
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-input {
  input {
    width: 75px;
    height: 30px;
  }
}
.van-popover__wrapper {
  white-space: normal;
  word-break: break-all;
  line-height: 1.4;
}
.tips {
  padding: 10px;
}
.detail-title {
  width: 100%;
  height: 50px;
  color: #555;
  background: #fff;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 600;
  padding: 17px;
  z-index: 9999;
  border-top-right-radius: 16px;
  border-top-left-radius: 16px;
  // border-bottom: 1px solid #f2f2f2;
  img {
    width: 14px;
    height: 14px;
  }
}
.container {
  width: 100%;
  font-size: 12px;
  margin-top: 45px;
  padding: 0 25px;
}
.info,
.qty {
  &-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    font-weight: 500;
    .info-name {
      color: #21b0e3;
      font-weight: normal;
    }
  }
  &-content {
    min-height: 150px;
    padding: 10px;
    padding-bottom: 0;
    border: 1px solid #eaeaea;
    border-radius: 6px;
    .info-item {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      div {
        width: 35%;
      }
      div:last-child {
        width: 70%;
      }
    }
  }
}
.qty {
  &-content {
    min-height: 100px;
    padding: 10px;
    margin-bottom: 10px;
    .content-title {
      font-weight: 500;
    }
    .content {
      margin-top: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .qty-item {
        width: 30%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        text-align: center;
        margin-left: -10px;
        div {
          height: 35px;
          line-height: 45px;
        }
      }
      .qty-item:nth-child(2) {
        margin-left: -20px;
      }
    }
  }
}
.btn-group {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 45px;
  // position: fixed;
  // left: 0;
  // bottom: 0;
  // padding: 10px 20px;
  // background-color: #fff;
  // margin-top: 28px;
  .btn {
    width: 120px;
    height: 35px;
    font-size: 13px;
    color: #4e7092;
    border-radius: 60px;
    background: #f2f2f2;
    line-height: 43px;
  }
  .van-button--info {
    background-color: #28b2ef;
    color: #fff;
    border: none;
  }
}
</style>
